import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { LoginService } from 'src/app/login.service';
import { TranslatorService } from 'src/app/translator.service';
import { GenericpopupComponent } from '../genericpopup/genericpopup.component';
import { getAuth, signOut } from 'firebase/auth';

class Port {
  public id: number;
  public name: string;
  public shortval: string;
}


@Component({
  selector: 'app-addtest',
  templateUrl: './addtest.component.html',
  styleUrls: ['./addtest.component.scss'],
})


export class AddtestComponent implements OnInit {

  @Input() testdata;
  @Input() questionsdata;
  @Input() cacheData;

  @Input() cityuser;
  @Input() email;
  @Input() school;
  @Input() nameuser;
  @Input() emailuid;


  public questions = [];
  public testname = '';
  public portlanguage: Port;
  public portClass: Port;
  public questionTypePort: Port[];
  public questionTypeVal: Port;
  public materieType: Port;
  public questionText = '';
  public answersLabel = ['a)', 'b)', 'c)', 'd)', 'e)', 'f)', 'g)', 'h)'];

  public selectedQuestion = -1;
  public previousSelectedQuestion = -1;
  public selectedAnswer = -1;
  public questionType = '-1';
  public answers = [];
  public pointsValue = 0;
  public saveButtonLabel = '';
  public isEditMode = false;
  public isCacheMode = false;
  public colSize = '12';
  public colSizeBtn = '12';
  constructor(public translatorService: TranslatorService, public loginService: LoginService, public modalCtrl: ModalController,) { }

  ngOnInit() {
    if (this.loginService.isDesktop) {
      this.colSize = '4';
      this.colSizeBtn = '3';
    }
    this.questionTypePort = [{
      id: 0, name: this.translatorService.translate('idx',
        '*Intrebare cu o singura varianta de raspuns.'), shortval: ''
    },
    { id: 1, name: this.translatorService.translate('idx', '*Intrebare cu variante multiple de raspuns'), shortval: '' }];
    this.saveButtonLabel = this.translatorService.translate('idx', '*Salveaza concurs (minim 5 intrebari)');
    if (this.questionsdata !== undefined && this.testdata !== undefined) {
      this.isEditMode = true;
      if (this.cacheData !== undefined) {
        this.isCacheMode = true;
      }
      this.saveButtonLabel = this.translatorService.translate('idx', '*Actualizeaza concurs');
      this.testname = this.testdata.testname;
      this.portlanguage = this.loginService.datalanguages[this.testdata.langid];
      this.portClass = this.loginService.dataClass[this.testdata.class];
      this.materieType = this.loginService.dataMaterie[this.testdata.materie]
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let k = 0; k < this.questionsdata.q.length; k++) {
        const quest = this.questionsdata.q[k];
        const answersval = quest.answers.split('|');
        const answersFormatted = [];
        let selectedAnswerVal = '';
        if (quest.questionType === '1') {
          selectedAnswerVal = quest.rightAnswer;
        }
        let multipleanswer;
        if (quest.questionType === '2') {
          multipleanswer = quest.rightAnswer.split(',');
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let j = 0; j < answersval.length; j++) {
          let valIsChecked = false;
          if (quest.questionType === '2') {
            valIsChecked = multipleanswer[j];
          }
          answersFormatted.push({ idx: this.answersLabel[j], ngval: answersval[j], isCheckedMultiple: valIsChecked });
        }
        this.questions.push({
          label: quest.label, question: quest.question, answers: answersFormatted, questionType: '' + quest.questionType,
          selectedAnswer: selectedAnswerVal, pointsValue: quest.points
        });
      }
    }
  }

  public addQuestion() {
    const questions = this.questions.length + 1;
    const labelval = this.translatorService.translate('idx', '*Intrebarea ');
    this.questions.push({
      label: labelval + questions, question: '',
      answers: [], questionType: '-1', selectedAnswer: -1, pointsValue: 0
    });
  }

  public deleteQuestion(idx) {
    this.questions.splice(idx, 1);
    if (idx === +this.selectedQuestion) {
      this.selectedQuestion = -1;
      this.previousSelectedQuestion = -1;
    }
  }

  public questionChanged() {
    if (this.previousSelectedQuestion === -1) {
      this.previousSelectedQuestion = this.selectedQuestion;
      this.questionText = this.questions[this.selectedQuestion].question;
      this.answers = this.questions[this.selectedQuestion].answers;
      this.questionType = this.questions[this.selectedQuestion].questionType;
      this.selectedAnswer = this.questions[this.selectedQuestion].selectedAnswer;
      this.pointsValue = this.questions[this.selectedQuestion].pointsValue;
    }
    else {
      if (+this.pointsValue > 20) { this.pointsValue = 20; }
      if (+this.pointsValue < 0) { this.pointsValue = 0; }
      this.questions[this.previousSelectedQuestion].question = this.questionText;
      this.questions[this.previousSelectedQuestion].answers = this.answers;
      this.questions[this.previousSelectedQuestion].questionType = this.questionType;
      this.questions[this.previousSelectedQuestion].selectedAnswer = this.selectedAnswer;
      this.questions[this.previousSelectedQuestion].pointsValue = this.pointsValue;
      this.previousSelectedQuestion = this.selectedQuestion;
      this.questionText = this.questions[this.selectedQuestion].question;
      this.answers = this.questions[this.selectedQuestion].answers;
      this.questionType = this.questions[this.selectedQuestion].questionType;
      this.selectedAnswer = this.questions[this.selectedQuestion].selectedAnswer;
      this.pointsValue = this.questions[this.selectedQuestion].pointsValue;
    }
  }

  public pointValueChanged(ev) {
    if (+this.pointsValue > 20) { this.pointsValue = 20; }
    if (+this.pointsValue < 0) { this.pointsValue = 0; }
  }
  public questionTypeChanged() {
    this.questions[this.selectedQuestion].questionType = this.questionType;
  }

  addAnswer() {
    const val = '';
    this.answers.push({ idx: this.answersLabel[this.answers.length], ngval: val, isCheckedMultiple: false });
    this.questions[this.selectedQuestion].answers = this.answers;
  }
  removeAnswer(idx) {
    this.answers.splice(idx, 1);
    let counter = 0;
    for (const i of this.answers) {
      this.answers[counter].idx = this.answersLabel[counter];
      counter++;
    }
    this.questions[this.selectedQuestion].answers = this.answers;
    if (idx === +this.selectedAnswer) {
      this.selectedAnswer = -1;
    }
  }

  cancelContest() {
    this.modalCtrl.dismiss({ status: false }, '');
  }
  async saveContest() {

    let message = '';
    message += '<br>';
    let isValid = true;
    if (this.portlanguage === undefined) {
      message += this.translatorService.translate('idx', '*Alege in ce limba este acest test! <br>');
      isValid = false;
    }
    if (this.portClass === undefined) {
      message += this.translatorService.translate('idx', '*Alege pentru ce clasa este acest test! <br>');
      isValid = false;
    }
    if (this.materieType === undefined) {
      message += this.translatorService.translate('idx', '*Alege pentru ce materie este acest test! <br>');
      isValid = false;
    }

    if (this.testname === '') {
      message += this.translatorService.translate('idx', '*Alege titlul pentru acest test! <br>');
      isValid = false;
    }
    if (this.questions.length === 0) {
      message += this.translatorService.translate('idx', '*Adauga intrebari pentru acest test! <br>');
      isValid = false;
    }
    let points = 0;
    if (this.questions.length > 0) {
      if (this.selectedQuestion !== -1) {
        this.questions[this.selectedQuestion].question = this.questionText;
        this.questions[this.selectedQuestion].answers = this.answers;
        this.questions[this.selectedQuestion].questionType = this.questionType;
        this.questions[this.selectedQuestion].selectedAnswer = this.selectedAnswer;
        this.questions[this.selectedQuestion].pointsValue = this.pointsValue;
      }
      message += '<br>';
      for (const q of this.questions) {
        if (q.question === '') {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx', '*Completeaza textul intrebarii! <br>');
          isValid = false;
        }
        if (q.answers.length < 4) {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx',
            '*Adauga raspunsuri la aceasta intrebare! Minim 4 raspunsuri pentru fiecare intrebare! <br>');
          isValid = false;
        }
        if (+q.questionType === -1) {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx', '*Alege tipul intrebarii! <br>');
          isValid = false;
        }
        if (+q.questionType === 1 && q.selectedAnswer === -1) {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx',
            '*Selecteaza raspunsul corect pentru aceasta intrebare! <br>');
          isValid = false;
        }
        for (const a of q.answers) {
          if (a.ngval === '') {
            message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx',
              '*Unul din raspunsurile pentru aceasta intrebare este incomplet! <br>');
            isValid = false;
            break;
          }
        }
        let achecked = 0;
        for (const a of q.answers) {
          if (a.isCheckedMultiple === true) {
            achecked++;
            break;
          }
        }
        if (+q.questionType === 2 && achecked === 0) {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx',
            '*Aceasta intrebare nu are nici un raspuns corect selectat! <br>');
          isValid = false;
        }
        if (+q.pointsValue === 0) {
          message += '<b>' + q.label + ':</b> ' + ' ' + this.translatorService.translate('idx',
            '*Aceasta intrebare nu are nici un punct alocat! <br>');
          isValid = false;
        }
        points += +q.pointsValue;
        message += '<br>';
      }
      if (points < 100) {
        message += this.translatorService.translate('idx', '*Suma totala a punctelor acordate nu este 100! <br>');
        isValid = false;
      }
      message += '<br>';
    }
    console.log(isValid);
    
    if (isValid === true) {
      const buttongroup = [{ label: this.translatorService.translate('idx', '*Ok'), action: 0 }];
      const titlelabel = this.translatorService.translate('idx', '*Acest test nu are completate toate informatiile.');
      this.modalCtrl.create({
        component: GenericpopupComponent,
        backdropDismiss: false,
        id: 'invalidtest',
        cssClass: this.loginService.isDesktop ? 'modal-generic' : 'modal-fullscreen',
        componentProps: { title: titlelabel, body: message, buttons: buttongroup }
      }).then(modalEl => {
        modalEl.present();
        return modalEl.onDidDismiss();
      }).then(resultData => {
      });

    }
    else {
      if (this.loginService.isAdmin) {
        //////////////////////ADMIN
        const userpath = '/tests/structure/' + this.portlanguage.shortval + '/' + this.portClass.id + '/' +
          this.emailuid;
        const testpath = '/tests/content/' + this.portlanguage.shortval + '/' + this.portClass.id + '/' +
          this.emailuid;
        const teacherpath = '/users/' + this.emailuid + '/tests/' +
          this.portlanguage.shortval + '/' + this.portClass.id;
        await this.loginService.grabdata(userpath).then((data: any) => {
          let counter = 0;
          if (data.data != null) {
            if (data.data.tests != null) {
              counter = data.data.tests.length;
            }
          }
          const teachervals = {
            name: this.nameuser,
            judet: this.cityuser,
            unitate: this.school
          };
          const accountdata = {
            name: this.nameuser,
            judet: this.cityuser,
            unitate: this.school,
            email: this.email
          };
          if (counter === 0) {
            this.loginService.updatedata(userpath, teachervals);
            this.loginService.updatedata('/users/' + this.emailuid + '/accountdata', accountdata);
          }

          const testvals = {
            title: this.testname,
            id: counter,
            materie: this.materieType.id,
            testconfirmed: false,
            dateAdded: new Date()
          };
          if (!this.isEditMode) {
            this.loginService.updatedata(userpath + '/tests/' + counter + '/', testvals);
            this.loginService.updatedata(teacherpath + '/' + counter, testvals);
          }
          else {
            this.loginService.updatedata(testpath + '/tests/' + counter, {});
            counter = this.testdata.testid;
          }
          let questcounter = 0;
          for (const quest of this.questions) {
            let rightAnswerVal = '';
            let answersval = '';
            if (+quest.questionType === 1) {
              rightAnswerVal = '' + quest.selectedAnswer;
            }
            else {
              for (let k = 0; k < quest.answers.length; k++) {
                rightAnswerVal += quest.answers[k].isCheckedMultiple;
                if (k !== quest.answers.length - 1) {
                  rightAnswerVal += ',';
                }
              }
            }
            for (let k = 0; k < quest.answers.length; k++) {
              answersval += quest.answers[k].ngval;
              if (k !== quest.answers.length - 1) {
                answersval += '|';
              }
            }
            const questionvals = {
              id: questcounter,
              label: quest.label,
              question: quest.question,
              questionType: quest.questionType,
              rightAnswer: rightAnswerVal,
              points: quest.pointsValue,
              answers: answersval
            };
            if (questcounter < this.questions.length - 1) {
              this.loginService.updatedata(testpath + '/tests/' + counter + '/q/' + questcounter, questionvals);
            }
            else {
              this.loginService.updatedata(testpath + '/tests/' + counter + '/q/' + questcounter, questionvals).then(() => {
                this.modalCtrl.dismiss({ status: true }, '');
              });
            }
            questcounter++;
          }
        });
        //////////////////////ADMIN
      }
      else {
        if (this.loginService.userAccount.uid === '' || this.loginService.userAccount.uid === undefined) {
          alert("Contul dumneavoastra nu este autentificat! Am salvat local progresul dumneavoastra. Va rugam sa va autentificati inca o data pentru a salva testul in cloud: " + this.loginService.userAccount.uid);
          window.localStorage.setItem('portlanguage.shortval', this.portlanguage.shortval);
          window.localStorage.setItem('portlanguage.id', "" + this.portlanguage.id);
          window.localStorage.setItem('portClass.id', "" + this.portClass.id);
          window.localStorage.setItem('title', this.testname);
          window.localStorage.setItem('materie', "" + this.materieType.id);
          window.localStorage.setItem('questionsize', "" + this.questions.length);
          let questcounter = 0;
          for (var quest of this.questions) {
            let rightAnswerVal = '';
            let answersval = '';
            if (+quest.questionType === 1) {
              rightAnswerVal = '' + quest.selectedAnswer;
            }
            else {
              for (let k = 0; k < quest.answers.length; k++) {
                rightAnswerVal += quest.answers[k].isCheckedMultiple;
                if (k !== quest.answers.length - 1) {
                  rightAnswerVal += ',';
                }
              }
            }
            for (let k = 0; k < quest.answers.length; k++) {
              answersval += quest.answers[k].ngval;
              if (k !== quest.answers.length - 1) {
                answersval += '|';
              }
            }
            window.localStorage.setItem('q' + questcounter + "_label", "" + quest.label);
            window.localStorage.setItem('q' + questcounter + "question", "" + quest.question);
            window.localStorage.setItem('q' + questcounter + "questionType", "" + quest.questionType);
            window.localStorage.setItem('q' + questcounter + "rightAnswer", "" + rightAnswerVal);
            window.localStorage.setItem('q' + questcounter + "points", "" + quest.pointsValue);
            window.localStorage.setItem('q' + questcounter + "answers", "" + answersval);
            questcounter++;
          }

          this.loginService.logout();
          this.modalCtrl.dismiss({}, '');
          return;
        }
        const userpath = '/tests/structure/' + this.portlanguage.shortval + '/' + this.portClass.id + '/' +
          this.loginService.userAccount.uid;
        const testpath = '/tests/content/' + this.portlanguage.shortval + '/' + this.portClass.id + '/' +
          this.loginService.userAccount.uid;
        const teacherpath = '/users/' + this.loginService.userAccount.uid + '/tests/' +
          this.portlanguage.shortval + '/' + this.portClass.id;
        await this.loginService.grabdata(userpath).then((data: any) => {
          let counter = 0;
          if (data.data != null) {
            if (data.data.tests != null) {
              counter = data.data.tests.length;
            }
          }
          const teachervals = {
            name: this.loginService.userAccount.name,
            judet: this.loginService.userAccount.localitate,
            unitate: this.loginService.userAccount.unitate
          };
          if (counter === 0) {
            this.loginService.updatedata(userpath, teachervals);
          }

          const testvals = {
            title: this.testname,
            id: counter,
            materie: this.materieType.id,
            testconfirmed: false,
            dateAdded: new Date()
          };
          if (!this.isEditMode || this.isCacheMode) {
            this.loginService.updatedata(userpath + '/tests/' + counter + '/', testvals);
            this.loginService.updatedata(teacherpath + '/' + counter, testvals);
          }
          else {
            this.loginService.updatedata(testpath + '/tests/' + counter, {});
            counter = this.testdata.testid;
          }
          let questcounter = 0;
          for (const quest of this.questions) {
            let rightAnswerVal = '';
            let answersval = '';
            if (+quest.questionType === 1) {
              rightAnswerVal = '' + quest.selectedAnswer;
            }
            else {
              for (let k = 0; k < quest.answers.length; k++) {
                rightAnswerVal += quest.answers[k].isCheckedMultiple;
                if (k !== quest.answers.length - 1) {
                  rightAnswerVal += ',';
                }
              }
            }
            for (let k = 0; k < quest.answers.length; k++) {
              answersval += quest.answers[k].ngval;
              if (k !== quest.answers.length - 1) {
                answersval += '|';
              }
            }
            const questionvals = {
              id: questcounter,
              label: quest.label,
              question: quest.question,
              questionType: quest.questionType,
              rightAnswer: rightAnswerVal,
              points: quest.pointsValue,
              answers: answersval
            };
            if (questcounter < this.questions.length - 1) {
              this.loginService.updatedata(testpath + '/tests/' + counter + '/q/' + questcounter, questionvals);
            }
            else {
              this.loginService.updatedata(testpath + '/tests/' + counter + '/q/' + questcounter, questionvals).then(() => {
                this.modalCtrl.dismiss({ status: true }, '');
              });
            }
            questcounter++;
          }
        });

      }
    }
  }
}
